export const extractUtm = (url: string) => {
  const regex = /(&|\?)utm_[^&\s]+/g;
  const matches = url.match(regex);
  if (matches) {
    return matches.join('');
  } else {
    return '';
  }
};
